module.exports = __webpack_public_path__ + "static/media/prenota.3a480378.png";